module.exports = __webpack_public_path__ + "img/download-btn.56760c48.svg";